import React from 'react';
import Link from 'next/link';
import { TagProps } from './types';

export const Tag: React.FC<TagProps> = ({
  label,
  className = '',
  isActive = false,
  onClick,
  href,
  ignoreSessionParams,
}) => {
  const baseClasses = [
    'inline-flex items-center justify-center',
    'px-3 h-10 rounded-full',
    'text-[12px] leading-4 font-semibold transition-all duration-200',
    isActive
      ? 'bg-primary-500 text-white border-[1.5px] border-primary-500'
      : 'bg-white border-[1.5px] hover:bg-primary-500/5',
    className,
  ].join(' ');

  const style = !isActive
    ? { color: 'rgb(0, 86, 163)', borderColor: 'rgb(0, 86, 163)' }
    : undefined;

  if (href) {
    return (
      <Link
        href={href}
        className={baseClasses}
        style={style}
        onClick={onClick}
        {...(ignoreSessionParams ? { 'data-ignore-session-params': 'true' } : {})}
      >
        {label}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={`${baseClasses} cursor-pointer`}
        style={style}
      >
        {label}
      </button>
    );
  }

  return (
    <span
      className={baseClasses}
      style={style}
    >
      {label}
    </span>
  );
};

export default Tag;
